export const checkObject = (value) => (typeof(value) === 'object' && !!value);